import { Plus } from 'lucide-react';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Button } from '@/Components/shadcn/button';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';
import { ExperienceCriteriaForm, experienceCriteriaFieldNames, maxExperienceCriteria } from '../ExperienceCriteriaForm';
import CriteriaField from './CriteriaField/CriteriaField';

interface IdentifyExperienceStepFieldsProps {
    experienceCriteriaProcessingState: ProcessingState;
    isEditMode: boolean;
}

const IdentifyExperienceStepFields = ({
    experienceCriteriaProcessingState,
    isEditMode,
}: IdentifyExperienceStepFieldsProps) => {
    const { formState } = useFormContext<ExperienceCriteriaForm>();
    const { fields, remove, append } = useFieldArray<ExperienceCriteriaForm>({
        name: experienceCriteriaFieldNames.criteria,
    });
    const isLoading = experienceCriteriaProcessingState === ProcessingState.Processing;
    const criteriaEmptyError =
        !fields.length && (formState.errors.criteria?.root?.message || formState.errors.criteria?.message);

    const appendExperienceRow = () => {
        if (!isEditMode) {
            append({ criteriaId: '', value: '' });
        }
    };

    return (
        <div className="bg-alicia rounded-lg p-5">
            <div className="flex flex-col gap-5">
                {isLoading
                    ? Array.from({ length: maxExperienceCriteria }).map((_key, index) => (
                          <CriteriaField
                              key={`key-${index.toString()}`}
                              index={index}
                              disabled
                              showDeleteButton={false}
                          />
                      ))
                    : fields.map((field, index) => (
                          <CriteriaField
                              key={field.id}
                              index={index}
                              showDeleteButton={!isEditMode}
                              name={`${experienceCriteriaFieldNames.criteria}.${index}.value`}
                              onRemove={() => remove(index)}
                          />
                      ))}
                {!isLoading && fields.length < maxExperienceCriteria && !isEditMode && (
                    <Button
                        type="button"
                        variant="outline"
                        className="h-35 w-full border-dashed"
                        onClick={appendExperienceRow}
                    >
                        <Plus className="size-4 shrink-0" />
                        {UIStrings.AddCriteria}
                    </Button>
                )}
                {criteriaEmptyError && <p className="text-destructive text-sm">{criteriaEmptyError}</p>}
            </div>
        </div>
    );
};

export default IdentifyExperienceStepFields;
